import React from 'react';
import { ShieldOff } from 'lucide-react';

export default function AccessBlocked() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center">
              <ShieldOff className="w-8 h-8 text-red-400" />
            </div>
          </div>
          <h1 className="text-xl font-semibold text-gray-800 mb-3">
            Acesso não permitido
          </h1>
          <p className="text-gray-500 text-sm leading-relaxed">
            Este endereço é exclusivo para o cadastro de clientes.<br />
            O acesso ao sistema interno não está disponível por aqui.
          </p>
        </div>
      </div>
    </div>
  );
}
